import { Action } from '@ngrx/store';

import * as actions from './requests.actions';
import { ReducerStateFactory } from '../state-factory.reducer';
import { PermissionRequestDto } from '@careapp-group/ng-sdk';

class RequestsState extends ReducerStateFactory<PermissionRequestDto> {
  constructor(actions, initialState = {}) {
    super(actions);
  }

  public reducer(state = this.initialState, action: Action) {
    switch (action.type) {
      case actions.Requests.REQUEST_APPROVE_REQUEST:
      case actions.Requests.REQUEST_DENY_REQUEST:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [(<any>action).payload.id]: true,
          },
        };
      case actions.Requests.RESPONSE_FAIL_RESPOND:
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [(<any>action).payload.id]: false,
          },
        };
      case actions.Requests.RESPONSE_SUCCESS_RESPOND:
        const entities = { ...state.entities };
        delete entities[(<any>action).payload.id];
        const ids = [...state.ids.filter((id) => id !== (<any>action).payload.id)];
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [(<any>action).payload.id]: false,
          },
          entities,
          ids,
        };
      default:
        return super.reducer(state, action);
    }
  }
}

export const state = new RequestsState(actions.Requests);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
